import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ITopic } from "../../utils/types/models";

export default createEntityReducer<ITopic>(Endpoint.Topics, Endpoint.TopicsList);
